module.exports = __webpack_public_path__ + "img/relevant-example-latest.abde018c.svg";